<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="60px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店">
                  <el-select v-model="queryForm.vendorIds" multiple filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店Id" label-width="70px">
                  <el-input type="number" v-model.number="queryForm.inputVendorId" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="商品对接方式" label-width="100px">
                  <el-select v-model="queryForm.productSourceType" clearable>
                    <el-option label="对方推送" :value="2"></el-option>
                    <el-option label="IM拉取" :value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-table :data="tableData">
      <el-table-column prop="vendorName" label="买手店"></el-table-column>
      <el-table-column prop="vendorId" label="Vendor Id"></el-table-column>
      <el-table-column prop="systemName" label="系统名称"></el-table-column>
      <el-table-column prop="productSourceType" label="商品对接方式"></el-table-column>
      <el-table-column prop="status" label="任务状态">
        <template slot-scope="scope">
          <template v-if="!scope.row.id">
            <span class="status-point gray"></span>
            任务未配置
          </template>
          <template v-if="scope.row.status === 'STOP'">
            <span class="status-point"></span>
            任务已关闭
          </template>
          <template v-if="scope.row.status === 'RUNNING' && !scope.row.lastRunStatus">
            <span class="status-point green"></span>
            任务已启动
          </template>
          <template v-if="scope.row.status === 'RUNNING' && scope.row.lastRunStatus">
            <i class="el-icon-loading"></i>
            任务执行中
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="jobDesc" label="job说明"></el-table-column>
      <el-table-column prop="nextExecuteTime" label="下次自动执行时间"></el-table-column>
      <el-table-column prop="executeTimeList" label="执行周期">
        <template slot-scope="scope">
          <el-tooltip effect="light" placement="right-start" v-if="scope.row.executeTimeList">
            <i class="el-icon-document"></i>
            <template slot="content">
              <p v-for="item in scope.row.executeTimeList" :key="item">{{ item }}</p>
            </template>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.isTrigger" @click="triggerRow(scope.row)">执行</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
// import cronstrue from 'cronstrue';
// import 'cronstrue/locales/zh_CN';
import {
  queryVendor,
  getXXLJobList,
  triggerXXLJob,
} from "../../../api/trace_cn";

export default {
  components: {
  },
  data() {
    return {
      vendorList: [],
      queryForm: {
        inputVendorId: null,
        vendorIds: [],
        productSourceType: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
    };
  },
  mounted() {
    queryVendor(true).then(res => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data;
      }
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.inputVendorId = null;
      this.queryForm.vendorIds = [];
      this.queryForm.productSourceType = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getXXLJobList({
        ...this.queryForm,
        vendorIds: this.queryForm.inputVendorId ? [this.queryForm.inputVendorId] : this.queryForm.vendorIds,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          let flag = false;
          this.tableData = (res.data.data.list || []).map(item => {
            if (item.lastRunStatus) {
              flag = true;
            }
            return item;
          });
          if (flag) {
            setTimeout(() => {
              this.getTableData();
            }, 5000);
          }
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    triggerRow(row) {
      this.$confirm(`确认执行${row.vendorName}任务吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        triggerXXLJob({
          vendorId: row.vendorId,
          id: row.id,
          groupId: row.groupId,
        }).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success('操作成功!');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
        })
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.status-point {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 3px;
  vertical-align: 2px;
  background-color: #F56C6C;
  border-radius: 6px;

  &.green {
    background-color: #67C23A;
  }
  &.gray {
    background-color: #909399;
  }
}
</style>
